var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "530px",
    height: "543px",
    viewBox: "0 0 530 543",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pixel-True-logo-text",
    transform: "translate(-2510.000000, -674.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2510.000000, 604.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PIXEL-TRUE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "258.092732 332.268555 303.255639 312.921588 286.518797 302.686418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF5886",
    points: "401.684211 270.982356 401.684211 283.58909 401.684211 341.380352 401.684211 372.834776 303.255639 312.921588 258.092732 332.268555 150.100251 444.480963 235.245614 474.437557 448.972431 395.177402 529.601504 216.311572"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF5886",
    points: "193.005013 360.103223 121.541353 434.370613 150.100251 444.480963 258.092732 332.268555"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#070707",
    opacity: 0.39,
    points: "173.478697 147.286587 130.308271 188.227266 117.954887 200.085084 117.954887 200.085084"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FF5886",
    points: "303.255639 312.921588 401.684211 372.834776 401.684211 341.380352 346.558897 294.573174"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.268170, 58.289795)",
    fill: "#433AF6",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "249.591479 0.125562779 270.047619 19.4725297 362.897243 107.345205 447.511278 19.4725297 466.107769 0.125562779"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.210526 88.9967916 100.686717 141.795288 0 237.656389 0 484.423832 19.6591479 463.953493 104.273183 376.080817 175.736842 301.813428 245.075188 229.792783 279.478697 193.96969 177.330827 106.970748"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.765377, 147.286587)",
    fill: "#070707",
    id: "Path",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3.77597618 287.084026 32.3348734 297.194376 140.327355 184.981968 75.2396353 212.816636"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.79352 147.286587 185.490262 165.635001 283.918833 225.548189 283.918833 194.093765"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.7133195 0 0.189510019 52.7984969 24.6306128 67.6519747 144.577981 140.795992 178.98149 104.972898 76.8336203 17.9739564"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DADAF6",
    points: "400.223058 184.60751 380.165414 165.635001 287.315789 77.7623252 266.859649 58.4153583 205.225564 0 0.398496241 0 173.478697 147.286587 194.598997 165.260543 296.746867 252.259485 317.867168 270.108622 346.558897 294.573174 401.684211 341.380352 401.684211 283.58909 401.684211 270.982356 401.684211 185.855702"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.775d113382a05227e38d993e0ec6e69f.svg";
export { ForwardRef as ReactComponent };